import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file\"><path d=\"M732.630746 0H125.83424A55.660874 55.660874 0 0 0 70.620631 55.896276v912.183908A55.660874 55.660874 0 0 0 125.83424 1024h772.331402A55.660874 55.660874 0 0 0 953.379251 968.103724V223.467402zM318.852355 325.749701h165.546667a27.954023 27.954023 0 0 1 0 55.896276H318.852355a27.954023 27.954023 0 0 1 0-55.896276zM705.029826 716.8H318.852355a27.954023 27.954023 0 0 1 0-55.896276H705.029826a27.954023 27.954023 0 0 1 0 55.896276z m0-167.571126H318.852355a27.954023 27.954023 0 0 1 0-55.896276H705.029826a27.954023 27.954023 0 0 1 0 55.896276z\" fill=\"#FFBA4C\" /><path d=\"M953.379251 228.752184H783.889596a57.061517 57.061517 0 0 1-56.496551-57.226299V0z m0 0\" fill=\"#FFDBA2\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file.svg
// module id = fQ0v
// module chunks = 48